import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import { PFE_ICONS } from 'constants/icons';
import { bem } from 'helpers/class-name';
import { Form, Input, Button } from 'components/HookForm';
import Message from 'components/Message';

import { resetPasswordFormMessages as messages, validationMessages } from './Auth.messages';

const PASSWORD_MIN_LENGTH = 6;
const PASSWORD_MAX_LENGTH = 25;

const { element } = bem('auth');

function ResetPassword(props) {
  const { handleSubmit } = props;

  return (
    <div className={element('wrapper')}>
      <Isvg className={element('logo')} src={PFE_ICONS.logotype} />
      <Form onSubmit={handleSubmit} className={element('form')}>
        {({ watch }) => {
          const password = watch('password');
          return (
            <>
              <Message message={messages.title} as="h1" className={element('header')} />
              <Message message={messages.hint} as="p" className={element('hint')} />
              <Input
                type="password"
                name="password"
                required
                minLength={{ value: PASSWORD_MIN_LENGTH, message: validationMessages.passwordLength }}
                maxLength={{ value: PASSWORD_MAX_LENGTH, message: validationMessages.passwordLength }}
                placeholder={messages.newPassword}
                className={element('input')}
                autoFocus
              />
              <Input
                type="password"
                name="confirmPassword"
                required
                minLength={{ value: PASSWORD_MIN_LENGTH, message: validationMessages.passwordLength }}
                maxLength={{ value: PASSWORD_MAX_LENGTH, message: validationMessages.passwordLength }}
                validate={{
                  value: value => password.length === value.length,
                  message: validationMessages.passwordMismatch,
                }}
                placeholder={messages.confirmPassword}
                className={element('input')}
              />
              <Message message={messages.submit} as={Button} type={Button.TYPES.SUBMIT} className={element('submit')} />
            </>
          );
        }}
      </Form>
    </div>
  );
}

ResetPassword.propTypes = {
  handleSubmit: PropTypes.func,
};

export default ResetPassword;
